/**
 * PanelResizeHandle — asa vertical de redimensionado para paneles laterales.
 *
 * Se renderiza DENTRO del panel (que debe ser `relative`/`absolute`/`fixed`),
 * pegada al borde indicado por `side`. Solo existe en desktop (`hidden
 * md:block`), así que en móvil los paneles conservan su comportamiento.
 *
 * Uso junto con `useResizablePanel`:
 *   const { isResizing, panelRef, handleProps } = useResizablePanel({...});
 *   <aside ref={panelRef} style={{ width }} className="relative ...">
 *     <PanelResizeHandle side="right" isResizing={isResizing} {...handleProps} />
 *
 * @param {"left"|"right"} side  borde del panel donde vive el asa
 * @param {boolean} isResizing
 * @param {Function} onPointerDown
 * @param {Function} onDoubleClick  restaura el ancho por defecto
 */
export default function PanelResizeHandle({
  side,
  isResizing,
  onPointerDown,
  onDoubleClick,
}) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label="Redimensionar panel"
      title="Arrastrar para redimensionar · doble clic para restaurar"
      onPointerDown={onPointerDown}
      onDoubleClick={onDoubleClick}
      className={`hidden md:block absolute top-0 bottom-0 z-[5] w-2.5 cursor-col-resize touch-none select-none group ${
        side === "left" ? "-left-1" : "-right-1"
      }`}
    >
      <div
        className={`absolute top-0 bottom-0 w-0.5 transition-colors ${
          side === "left" ? "left-1" : "right-1"
        } ${isResizing ? "bg-primary-vivid" : "bg-transparent group-hover:bg-primary-vivid/60"}`}
      />
    </div>
  );
}
